var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"webview-main"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }